<!--  -->
<template>
    <div class='content'>
        <el-breadcrumb separator="/" class="breadcrumbs">
            <el-breadcrumb-item :to="{ path: '/memberList' }">{{ language['会员管理'][LT] }}</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">{{ language['消费记录'][LT] }}</a></el-breadcrumb-item>
        </el-breadcrumb>
        <div class="record_details">
            <div class="sgreen">
                <span>{{ language['时间'][LT] }}</span>
                <el-date-picker
                    v-model="times"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    :start-placeholder="language['开始日期'][LT]"
                    :end-placeholder="language['结束日期'][LT]">
                </el-date-picker>
                <el-button type="info" style="margin-left: 12px;" @click="reset()">{{ language['重置'][LT] }}</el-button>
                <el-button type="info" @click="inquire()">{{ language['查询'][LT] }}</el-button>
            </div>
            <div class="table">
                <el-table :data="tableData" border :header-cell-style="{ background: '#eee', }" style="width: 100%"
                    :empty-text="language['暂无数据'][LT]">
                    <el-table-column type="index" align="center" label="ID" width="180"></el-table-column>
                    <el-table-column prop="name" align="center" :label="language['手机号'][LT]" width="180">
                        <template slot-scope="scope">{{ scope.row.user.mobile }}</template>
                    mobile</el-table-column>
                    <el-table-column prop="name" align="center" :label="language['姓名'][LT]" width="180">
                        <template slot-scope="scope">{{ scope.row.user.name }}</template>
                    </el-table-column>
                    <!-- <el-table-column prop="address" align="center" :label="language['消费类型'][LT]"></el-table-column> -->
                    <el-table-column prop="change_money" align="center" :label="language['金额(元)'][LT]"></el-table-column>
                    <el-table-column prop="create_time" align="center" :label="language['消费时间'][LT]"></el-table-column>
                    <el-table-column prop="sy_name" align="center" :label="language['收银员'][LT]"></el-table-column>
                    <el-table-column prop="remark" align="center" :label="language['备注'][LT]"></el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            id:'',
            tableData:[],
            times:[],
            page:1,
            total:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 切换分页 
        getChange(event) {
            this.page = event;
            this.tableData = [];
            this.getList();
        },
        // 重置
        reset(){
            this.times = []
            this.getList()
        },
        // 搜索
        inquire(){
            this.getList()
        },
        getList(){
            this.$post('64d59a663b865', { page:this.page,id:this.id,end_time:this.times[1]|| '',start_time:this.times[0]|| ''}).then(res => {
                if (res.code == 1) {
                    console.log(res);
                    this.tableData = res.data.data
                }else{
                    console.log(res);
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.id = this.$route.query.id
        this.getList()
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    /* height: 100vh; */
    padding: 20px;
    box-sizing: border-box;
}

.breadcrumbs {
    margin-bottom: 20px;
}

.record_details {
    padding: 15px;
    background: #fff;
}

.sgreen {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;

}

.sgreen span {
    margin-right: 20px;
}

.times {
    margin-right: 20px;
}

.table {
    margin-top: 20px;
}

.page {
    margin-top: 20px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/consumptionRecords.vue